import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_MAW_ORDERS_LIST } from '../queries/GetOrdersList';

const fetchOrdersData = async ({ queryKey }) => {
    const [, { esoi, filtersInfo, downloadUserImg, validateFilters, orderBy, token, department, filterOrders, startFilter, productName, username, accounts, profileImage, setLoadingEsoi, visibleColumns }] = queryKey;
  
  try {
    setLoadingEsoi(esoi);
    let finalFilter = { logic: 'or', filters: [] };

    if (filtersInfo?.filters?.length) {
      finalFilter.filters = [...filtersInfo.filters];
    }
    if (filterOrders?.filters?.length) {
      finalFilter.filters = [...finalFilter.filters, ...filterOrders.filters];
    }

    if (!validateFilters(finalFilter, filterOrders, startFilter)) {
      throw new Error('Invalid filters');
    }
    if (!token) throw new Error('Token not available');

    const response = await axios.post(
      `/Orders/pagedFilter/${encodeURIComponent('draftingDueDate')}`,
      {
        prodFamilyId: department,
        dateColumn: 'DraftingDueDate',
        sort: orderBy || 'asc',
        skip: 0,
        take: 1000,
        initFilter: JSON.stringify(startFilter, null, 2),
        filter: filtersInfo ? JSON.stringify(finalFilter, null, 2) : JSON.stringify(filterOrders, null, 2),
        viewAlias: 0,
        productName: productName,
        visibleColumns: visibleColumns
      },
      { headers: { Authorization: token } }
    );

    const ordersWithIndex = response.data.items.map((order, index) => ({
      ...order,
      rowIndex: index + 1,
    }));
    
    const uniqueEmployeePicURLs = new Map();

    const ordersWithImages = await Promise.all(
      ordersWithIndex.map(async (order) => {
        let isDetailer = false;
        let employeeId =
          username === order.designerChecker && username !== order.designerDetail
            ? ((isDetailer = true), order.desDetailEmpId)
            : username === order.designerDetail && username !== order.designerChecker
            ? order.desCheckerEmpId
            : order.desDetailEmpId;

        if (employeeId) {
          const responseEmployee = await axios.get(`/GetEmployeePicURL/${employeeId}`, {
            headers: { Authorization: token },
          });

          const employeePicUrl = responseEmployee.data.employeePicUrl;
          uniqueEmployeePicURLs.set(employeePicUrl, null);

          return {
            ...order,
            imageCheckerUrl: isDetailer ? '/DefaultProfile.png' : employeePicUrl,
            imageDetailerUrl: isDetailer ? employeePicUrl : '/DefaultProfile.png',
          };
        }
        return {
          ...order,
          imageCheckerUrl: '/DefaultProfile.png',
          imageDetailerUrl: '/DefaultProfile.png',
        };
      })
    );

    await Promise.all(
      [...uniqueEmployeePicURLs.keys()].map(async (url) => {
        uniqueEmployeePicURLs.set(url, await downloadUserImg(url));
      })
    );

    ordersWithImages.forEach((order) => {
      order.imageDetailerUrl =
        order.designerDetail === username ? profileImage : uniqueEmployeePicURLs.get(order.imageDetailerUrl) || '/DefaultProfile.png';
      order.imageCheckerUrl =
        order.designerChecker === username ? profileImage : uniqueEmployeePicURLs.get(order.imageCheckerUrl) || '/DefaultProfile.png';
    });

    return { orders: ordersWithImages, totalRows: response.data.totalRows };
  } catch (error) {
    throw error.response ? new Error(error.response.data) : error;
  }
};


export const useGetMAWOrdersData = (params) => {
  return useQuery({
    queryKey: [GET_MAW_ORDERS_LIST, params],
    queryFn: fetchOrdersData,
    enabled: !!params.token,
    retry: false,
  });
};